export const successResponseMockStructure = (data: { [key: string]: object } | object) => {
  return {
    ok: true,
    statusCode: 200,
    data: {
      success: true,
      ...data,
    },
    message: 'Operation Successful',
  }
}
